/* eslint-disable camelcase */

export enum UserType {
  basic = 2,
  admin = 1024,
}

export enum UserExpertise {
  occasional = 1,
  beginner = 2,
  experimented = 3,
  professional = 10,
}

export interface UserDto {
  username: string;
  created: string;
  id: number;
  // logo: null
  name: string;
  first_name?: string;
  last_name?: string;
  type: UserType | number;
  company?: string | null;
  expertise: UserExpertise;
}
